import { List, ValueEncoder } from 'DiscoveryEngine.TS/Utils';
import { ObjectSerializer, ObjSerUtils } from 'DiscoveryEngine.TS/Serialization';


export class GoogleWorkspaceSettingsDto implements ObjectSerializer {

	private static readonly Default_Enabled: boolean = false;
	private static readonly Default_QueryPageSize: number = 50;
	private static readonly Default_AutoSyncDirectoryData_Enabled: boolean = false;

	public Enabled: boolean;
	public DomainNames: List<string>;
	public QueryPageSize: number;
	public AutoSyncDirectoryData_Enabled: boolean;
	public AutoSyncDirectoryData_Days: number;
	public AutoSyncDirectoryData_Hours: number;
	public AutoSyncDirectoryData_Minutes: number;

	constructor() {
		this.Enabled = GoogleWorkspaceSettingsDto.Default_Enabled;
		this.DomainNames = new List<string>();
		this.QueryPageSize = GoogleWorkspaceSettingsDto.Default_QueryPageSize;
		this.AutoSyncDirectoryData_Enabled = GoogleWorkspaceSettingsDto.Default_AutoSyncDirectoryData_Enabled;
		this.AutoSyncDirectoryData_Days = 0;
		this.AutoSyncDirectoryData_Hours = 0;
		this.AutoSyncDirectoryData_Minutes = 0;
	}

	public get HasDomainNames(): boolean {
		return (!!this.DomainNames && this.DomainNames.Count > 0);
	}

	public Write(obj: any, context: any): void {

		obj.google_workspace_settings = {};
		obj = obj.google_workspace_settings;

		obj.enabled = ValueEncoder.EncodeBoolean(this.Enabled);

		if (this.HasDomainNames) {
			obj.domain_names = [];
			ObjSerUtils.WriteStringValueCollection(obj.domain_names, this.DomainNames, context);
		}

		obj.query_page_size = ValueEncoder.EncodeInteger(this.QueryPageSize);
		obj.auto_sync_directory_data_enabled = ValueEncoder.EncodeBoolean(this.AutoSyncDirectoryData_Enabled);
		obj.auto_sync_directory_data_days = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Days);
		obj.auto_sync_directory_data_hours = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Hours);
		obj.auto_sync_directory_data_minutes = ValueEncoder.EncodeInteger(this.AutoSyncDirectoryData_Minutes);
	}

	public Read(obj: any, context: any): void {

		if (!obj.google_workspace_settings)
			throw new Error();
		obj = obj.google_workspace_settings;

		if (obj.enabled !== undefined) {
			this.Enabled = ValueEncoder.DecodeBoolean(obj.enabled);
		}

		if (obj.domain_names !== undefined) {
			ObjSerUtils.ReadStringValueCollection(obj.domain_names, this.DomainNames, context);
		}

		if (obj.query_page_size !== undefined) {
			this.QueryPageSize = ValueEncoder.DecodeInteger(obj.query_page_size);
		}

		if (obj.auto_sync_directory_data_enabled !== undefined) {
			this.AutoSyncDirectoryData_Enabled = ValueEncoder.DecodeBoolean(obj.auto_sync_directory_data_enabled);
		}

		if (obj.auto_sync_directory_data_days !== undefined) {
			this.AutoSyncDirectoryData_Days = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_days);
		}

		if (obj.auto_sync_directory_data_hours !== undefined) {
			this.AutoSyncDirectoryData_Hours = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_hours);
		}

		if (obj.auto_sync_directory_data_minutes !== undefined) {
			this.AutoSyncDirectoryData_Minutes = ValueEncoder.DecodeInteger(obj.auto_sync_directory_data_minutes);
		}
	}

}
